<template>
  <div class="arrow-placement">
    <div class="buttons">
      <button
        class="control-btn"
        :class="{ 'control-btn-selected': isHidden }"
        @click="setHidden"
      >
        {{ $t('create.step3.arrowPlacement.hide') }}
      </button>

      <button
        class="control-btn"
        :class="{ 'control-btn-selected': isOnTop }"
        @click="setOnTop"
      >
        {{ $t('create.step3.arrowPlacement.onTop') }}
      </button>

      <button
        class="control-btn"
        :class="{ 'control-btn-selected': isOnSides }"
        @click="setOnSides"
      >
        {{ $t('create.step3.arrowPlacement.onSides') }}
      </button>
    </div>
  </div>
</template>


<script>
export default {
  name: 'ArrowPlacementButtons',
  props: {
    formatObject: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isHidden() {
      return this.formatObject.hideCarouselArrows === true;
    },
    isOnTop() {
      return this.formatObject.hideCarouselArrows === false
        && this.formatObject.arrowsOverCarousel === true;
    },
    isOnSides() {
      return this.formatObject.hideCarouselArrows === false
        && this.formatObject.arrowsOverCarousel === false;
    },
  },
  methods: {
    setHidden() {
      if (this.disabled) return;
      this.$emit('change-format-object', { inputFor: 'hideCarouselArrows', value: true });
      this.$emit('change-format-object', { inputFor: 'arrowsOverCarousel', value: false });
    },
    setOnTop() {
      if (this.disabled) return;
      this.$emit('change-format-object', { inputFor: 'hideCarouselArrows', value: false });
      this.$emit('change-format-object', { inputFor: 'arrowsOverCarousel', value: true });
    },
    setOnSides() {
      if (this.disabled) return;
      this.$emit('change-format-object', { inputFor: 'hideCarouselArrows', value: false });
      this.$emit('change-format-object', { inputFor: 'arrowsOverCarousel', value: false });
    },
  },
};
</script>

<style scoped lang="scss">
.arrow-placement {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  &:hover { background-color: $settings-hover; }
}

.title {
  @include base-font;
  @include font-small;
}

.buttons {
  display: flex;
  justify-content: center;
  width: 100%;

  .control-btn {
    background: transparent;
    @include base-font;
    @include font-smaller;
    color: $medium-grey;
    border: 1px solid $medium-grey;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 6px 0;
    height: 36px;
    &:hover { cursor: pointer; }
  }
  .control-btn:first-child {
    border-right: none;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }
  .control-btn:last-child {
    border-left: none;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .control-btn-selected {
    background-color: $dark-purple;
    color: white;
    border: 1px solid $dark-purple;
  }

}
</style>
